import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SingleHint from './single-hint';

const styles = theme => ({
    root: {
        width: '100%'
    },
    column: {
        padding: '20px'
    },
    video: {
        margin: '0 auto'
    }
});

class RoomHints extends React.Component {

    render() {
        const { pageContext: { room }, classes } = this.props;
        return (
            <div className={classes.root}>
                <div className={classes.column}>
                    <h1>{room.name}</h1>
                    {room.hints.map((hint, index) => (
                        <SingleHint key={index} content={hint} />
                    ))}
                    {room.videoId ?
                        <SingleHint content={
                            <iframe width="560" height="315" src={`https://www.youtube.com/embed/${room.videoId}`}
                                frameBorder="0" title={`${room.name} Video Walkthrough`}
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen className={classes.video} />
                        } /> : null
                    }
                </div>
            </div>
        );
    }

}

RoomHints.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styles)(RoomHints);